import React from 'react'
import { Stack, Divider, IconButton, FormGroup, FormControlLabel, Switch, } from '@mui/material';
import SbcCommon from './SbcCommon';
import MultiLangDialogAndSingleDisplayIpt from './MultiLangDialogAndSingleDisplayIpt';
import SbcOptions from './SbcOptions';
import SbcWrapper from './SbcWrapper';

// sidebar panel for radio
export default function SbcRadio({
    data,
    handleIptChange,
    handleOptions,
    handleSwitchChange,
    handleSelectChange,
    handleMultiIptChange,
    handleDragOptions
}) {
    return (
        <SbcWrapper>
            <SbcCommon
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
            />
            <SbcOptions
                data={data}
                handleIptChange={handleIptChange}
                handleMultiIptChange={handleMultiIptChange}
                handleSwitchChange={handleSwitchChange}
                handleSelectChange={handleSelectChange}
                handleOptions={handleOptions}
                handleDragOptions={handleDragOptions}
            />
        </SbcWrapper>
    )
}
